<template>
  <v-card :class="{'pt-1 elevation-0': isMobile, 'pt-1 elevation-1': !isMobile}">
        <v-card-title class="justify-center">
         <h2>Delivery Details</h2>
        </v-card-title>

    <v-divider color="#42A5F5"></v-divider>

    <v-container container--fluid grid-list-sm>
       <v-row align="center">
        <v-col cols="12" class="py-0" v-for="(key, indexKey) in Object.keys(infoItems)" :key="indexKey">
          <v-list class="no-padding-mobile">
            <v-list-item>
              <v-list-item-action>
                <div v-if="key === 'status'">
                  <v-icon v-if="trackingInfo[key] === 'Processed'" color="green">{{icons[key]}}</v-icon>
                  <v-icon v-if="trackingInfo[key] === 'Canceled'" color="red">{{icons[key]}}</v-icon>
                  <v-icon v-if="trackingInfo[key] === 'Pending'" color="orange">{{icons[key]}}</v-icon>
                  <v-icon v-if="trackingInfo[key] === 'On Hold'" color="orange">warning</v-icon>
                </div>
                <v-icon v-else>{{icons[key]}}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-subtitle>{{infoItems[key]}}</v-list-item-subtitle>
                  {{trackingInfo[key]}}
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>

        <v-col cols="12">
          <v-list-item>
            <v-list-item-action>
              <v-icon>access_time</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{time}}</v-list-item-title>
              <v-list-item-subtitle>{{timeField}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
       </v-row>

       <v-row justify="space-around" v-if="showMap">
        <v-col cols="12" sm="10" md="10" lg="10" class="pa-0">
          <v-card-text dark class="pa-0">
            <GmapMap
              :center="geocode"
              :zoom="12.8"
              map-type-id="terrain"
              style="height: 300px; width: 100%"
            >
              <GmapMarker
                :position="geocode"
                :clickable="true"
                @click="center=geocode"
              />

              <GmapCircle
                v-if="showDriverCircle"
                :center="driver_center"
                :radius="driver_radius"
                :visible="true"
                :fillOpacity="1.0"></GmapCircle>

            </GmapMap>
          </v-card-text>
        </v-col>
       </v-row>

    </v-container>

  </v-card>
</template>

<script>
  export default {
    name: "TrackPageInfo",
    props: {
      trackingInfo: Object,
      geocode: Object,
      timeField: String,
      fontStyle: String,
      fontStyleHeader: String,
      time: String,
      showMap: Boolean,
      showDriverCircle: Boolean,
      isMobile: Boolean,
    },
    data() {
      return {
        driver_center: {lat: 0, lng: 0},
        driver_radius: null,
        icons: {
          name: 'person',
          street1: 'location_on',
          region_name: 'location_city',
          date: 'event_note',
          tracking: 'track_changes',
          invoice: 'card_travel',
          instructions: 'chat',
          sender: 'supervisor_account',
          status: 'fiber_manual_record',
        },
        infoItems: {
          name: 'Name',
          street1: 'Address 1',
          sender: 'Sender',
          invoice: 'Invoice Number',
          instructions: 'Delivery Instructions',
          status: 'Status',
        }
      }
    },
    mounted() {
      if (this.trackingInfo.status === 'Pending' && this.trackingInfo.vehicle_location !== null) {
        if (this.showDriverCircle) {
          this.driver_center = {
            lat: this.trackingInfo.vehicle_location.vehicle_latitude,
            lng: this.trackingInfo.vehicle_location.vehicle_longitude
          };
          this.driver_radius = this.trackingInfo.vehicle_location.vehicle_location_radius;
        } else {
        }
        if (this.geocode === null || this.geocode === undefined) {
        }
      } else {

      }
    },
  }

</script>

<style scoped>
  @media (max-width: 480px) {
    .subscribe-box .block, .container {
      width: 300px;
    }

    .no-padding-mobile {
      padding: 0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/util/TrackPageInfo.vue